module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/e29154de12e97d6de7c6f90648f3cc7b.svg";